import React, { useState } from "react"

import ConnectorDialog from "../../ConnectorDialog"
import { FileUpload, Button } from "~/ui-rtk/components/ui/controls"
import { useConnect } from "./connect"

import { connectorIcons } from "~/ui-rtk/shared/constants/image-paths.contants"

import type { CustomConnectorDialogFormProps } from "../types"

type TargetFormType = Omit<CustomConnectorDialogFormProps, "uri">

const TargetForm: React.FC<TargetFormType> = ({
  isOpen,
  companyConnectorId,
  onClose,
}) => {
  const { authenticate, handleError, uploadFilesToS3, isLoading } = useConnect()
  const [error, setError] = useState("")
  const [uploadFiles, setUploadFiles] = useState<File[]>([])

  const handleConnect = async () => {
    setError("")

    if (!companyConnectorId) {
      throw new Error("Missing company connector id")
    }

    if (!uploadFiles.length) {
      setError("You haven't uploaded any files yet")
      return
    }

    try {
      const keys = await uploadFilesToS3(uploadFiles, companyConnectorId)
      await authenticate(companyConnectorId, keys)
      onClose()
    } catch (err) {
      handleError(err)
    }
  }

  const handleUpload = (files: FileList | null) => {
    setError("")
    setUploadFiles(files ? Array.from(files) : [])
  }

  return (
    <ConnectorDialog
      imgSrc={connectorIcons.target}
      alt="Target Logo"
      title="Target Performance Metrics"
      isOpen={isOpen}
      onClose={onClose}
    >
      <p className="leading-5 text-left text-base text-platinum">
        Upload your latest Target Performance Metrics CSV:
      </p>

      <div className="space-y-9 mb-2">
        <FileUpload
          onUpload={handleUpload}
          classes={{
            button:
              "bg-platinum/[.8] text-black hover:bg-platinum hover:text-black",
          }}
        />

        <Button
          variant={{ variant: "solid", color: "white" }}
          onClick={handleConnect}
          isLoading={isLoading}
          className="w-full mt-10 mb-2"
        >
          Connect
        </Button>
      </div>
      {error ? (
        <span className="text-sm text-center text-error">{error}</span>
      ) : null}
    </ConnectorDialog>
  )
}

export default TargetForm
